export default [
  {
    title: 'Clinical Trial Phases',
    component: 'ClinicalTrialPhases',
    bg: 'clinical-trial-phases',
    shortContext: 'STATECS team will cover all your needs throughout all the phases of your clinical trial to the highest industry ethical standards.',
  },
  {
    title: 'ISS ISE Services',
    component: 'IssIseServices',
    bg: 'ise-services',
    shortContext: 'If you want to get FDA approved, you need to have your integrated summaries ready on time and compatible with the regulatory standards. We can handle that for you.',
  },
  {
    title: 'Therapeutic Experience',
    component: 'TherapeuticExperience',
    bg: 'therapeutic-experience',
    shortContext: 'STATECS expertise in the therapeutic industry extends upon all major areas including oncology, cardiovascular, dermatology, and many more.',
  },
  {
    title: 'CDISC Compliant/Mapping',
    component: 'CdiscCompliantMapping',
    bg: 'cdisc-compliant-mapping',
    shortContext: 'CDISC compliance is an important indicator of the high quality of your clinical trial. Besides, you cannot do without it if you want to be FDA-approved. We will help you meet all the CDISC standards and successfully submit your trial results to the FDA.',
  },
  {
    title: 'Function Service Providers',
    component: 'FunctionServiceProviders',
    bg: 'function-service-providers',
    shortContext: 'Outsource your biometric team needs to STATECS and gain fast access to experienced professionals who will handle your clinical trial tasks in no time delivering effective results.',
  },
];
